import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useVersionSelectContextMenu } from '../../context';

type EditPropsType = {
  disabled?: boolean;
};

export const Edit: React.FC<EditPropsType> = ({ disabled }) => {
  const { t } = useTranslation();
  const { openEdit } = useVersionSelectContextMenu();

  return (
    <Menu.Item
      leftSection={
        <FontAwesomeIcon color="var(--mantine-color-blue-8)" icon={faEdit} />
      }
      onClick={openEdit}
      disabled={disabled}
    >
      {t('VERSION_SELECT.MENU.EDIT')}
    </Menu.Item>
  );
};
